var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"component-event-link",class:{ disabled: !_vm.href },attrs:{"download":_vm.link.type === 'downloadEvent',"href":_vm.href},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }